import { makeModelActions } from '@minerva-analytics/pantheon';
import { API_BASE } from 'utils';

import * as changePage from './changePage';

export default {
  ...makeModelActions({
    model: `category`,
    pluralModel: `categories`,
    endpoint: `quiz_categories`,
    baseUrl: API_BASE,
  }),
  ...changePage,
};
